import { Overlay, OverlayContent } from 'foundations-components/transitional/components/Overlay';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ResponsiveReportContainer from '../../shared/ResponsiveReportContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useProgressiveLoadingText from '../../shared/hooks/useProgressiveLoadingText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const breakpoints = [{
  text: 'reporting-snowflake.journey-load.refreshing',
  ms: 0
}, {
  text: 'reporting-snowflake.journey-load.continuing',
  ms: 2000
}, {
  text: 'reporting-snowflake.journey-load.still',
  ms: 8000
}];
const JourneyLoadingOverlay = () => {
  const loadingTextKey = useProgressiveLoadingText(breakpoints);
  return /*#__PURE__*/_jsx(ResponsiveReportContainer, {
    children: /*#__PURE__*/_jsx(View, {
      blockSize: "400px",
      children: /*#__PURE__*/_jsx(Overlay, {
        contextual: true,
        use: "light",
        width: 250,
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-around",
          minBlockSize: "100%",
          children: /*#__PURE__*/_jsx(OverlayContent, {
            children: /*#__PURE__*/_jsxs(Flex, {
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-around",
              minBlockSize: "100%",
              children: [/*#__PURE__*/_jsx(LoadingSpinner, {}), /*#__PURE__*/_jsx(FormattedMessage, {
                message: loadingTextKey
              })]
            })
          })
        })
      })
    })
  });
};
export default JourneyLoadingOverlay;